import * as React from 'react';
import { useLogger } from 'Client/logger/LoggerProvider';

interface ExperimentProps {
    name: string;
    activeVariant: string;
}

const Experiment = ({ name, activeVariant, children }: React.PropsWithChildren<ExperimentProps>) => {
    const logger = useLogger();

    let selectedVariant;

    React.Children.forEach(children, element => {
        if (
            React.isValidElement(element) &&
            (activeVariant === element.props.name || element.props.name.includes(activeVariant))
        ) {
            selectedVariant = element;
        }
    });

    if (!React.isValidElement(selectedVariant)) {
        logger.error(`Experiment "${name}" is running without a matching variant component.`);
    }

    return selectedVariant || null;
};

interface VariantProps {
    name: string | string[];
}

const Variant = ({ children }: React.PropsWithChildren<VariantProps>) => {
    return React.isValidElement(children) ? children : null;
};

Experiment.Variant = Variant;

export { Experiment };
